module.exports = __webpack_public_path__ + "img/8img_page-0001.c02a1b4d.jpg";